import * as  numeral from 'numeral'
import Big from 'big-js'
const trillion = 1000000000000
const billion = 1000000000
const million = 1000000
const hundredthousand = 100000
const thousand = 1000

String.prototype.countDecimals = function () {
    if (Math.floor(this.valueOf()) === this.valueOf()) return '0';
    return this.toString().split(".")[1].length || 0;
}

const Formatter = {
    toCurrency: (value, symbol) => {
        return numeral(value).format(`$0,0.00`)
    },
    toCurrencyTrim: (value, symbol) => {
        value = value || 0
        let abs = Math.abs(value)
        if (abs >= million) {
            return numeral(value).format(`$0,0[.][000]am`)
        } else {
            return numeral(value).format(`$0,0`)
        }
    },
    toDecimal: (value) => {
        value = value || 0
        let abs = Math.abs(value)
        if (abs >= million) {
            return numeral(value).format(`0,0[.][000]am`)
        } else {
            return numeral(value).format(`0,0[.][0000000000000000]`)
        }
    },
    toDecimalTrim: (value) => {
        value = value || 0
        let abs = Math.abs(value)
        if (abs >= billion) {
            return numeral(value).format(`0,0[.][000]ab`)
        } if (abs >= million) {
            return numeral(value).format(`0,0[.][000]am`)
        } if (abs >= thousand) {
            return numeral(value).format(`0,0`)
        } else {
            return numeral(value).format(`0,0[.][00000000]`)
        }
    },
    toDecimalTrim9: (value) => {
        value = value * 1
        value = new Big(value)
        value = value.toFixed(7)
        value = value.toString()

        value = value || '0'
        let decimalCount = value.countDecimals()
        let numberOfDecimalPlaces = decimalCount >= 8 ? 8 : decimalCount
        let zeroesFormat = ''

        if (numberOfDecimalPlaces <= 2) {
            zeroesFormat = '00'
        } else {
            for (let x = 0; x < numberOfDecimalPlaces; x++) {
                zeroesFormat += '0'
            }
        }

        let abs = Math.abs(value)
        if (abs >= million) {
            return numeral(value).format(`0,0[.][${zeroesFormat}]am`)
        } else if (abs >= hundredthousand) {
            return numeral(value).format(`0,0`)
        } else if (abs >= 10000) {
            return numeral(value).format(`0,0[.][${zeroesFormat}]`)
        } else if (abs >= 1000) {
            return numeral(value).format(`0,0[.][${zeroesFormat}]`)
        } else if (abs >= 100) {
            return numeral(value).format(`0,0[.][${zeroesFormat}]`)
        } else if (abs >= 10) {
            return numeral(value).format(`0,0[.][${zeroesFormat}]`)
        } else {
            const parsedNumber = numeral(value).format(`0,0[.][00000000]`)
            if (parsedNumber == 'NaN') {
                return value
            }
            return parsedNumber
            // return value
            //return numeral(value).format(`0,0[.][00000000]`)
        }
    },
    roundUp: (num, precision) => {
        precision = Math.pow(10, precision);
        return Math.round(num * precision) / precision;
    }
}
export default {
    Formatter
}
